<template>
  <div>
    <div v-loading="loading">
      <div class="d-flex">
        <div class="pr-2">
          <el-image
            :src="defaultImageUrl"
            :preview-src-list="[defaultImageUrl]"
            style="width:100px; height:100px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width:100px; height:100px"
              />
            </div>
          </el-image>
        </div>
        <div style="flex:1">
          <div class="el-descriptions">
            <div class="el-descriptions__body">
              <div
                class="el-descriptions__table is-bordered el-descriptions--small"
              >
                <div class="el-descriptions-row">
                  <div
                    class="el-descriptions-item__cell el-descriptions-item__label is-bordered-label"
                  >
                    <div class="sku_main">
                      <div>
                        <span v-if="formData.goodsName">
                          {{ formData.goodsName }}
                        </span>
                        <span v-if="formData.goodsNameEn">
                          {{ formData.goodsNameEn }}
                        </span>
                        <span v-if="formData.masterCategoryName">
                          {{ `(${formData.masterCategoryName})` }}
                        </span>
                      </div>
                      <div>
                        <span v-if="formData.amzSkuNo">
                          {{ formData.amzSkuNo }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-descriptions border size="small" class="bottom-desc" :column="3">
            <el-descriptions-item
              :label="$l('form_label_amzSkuNo') || 'SKU'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ formData.amzSkuStoreNo }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_asinCode') || 'ASIN'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ formData.asinCode }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fnskuCode') || 'FNSKU'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ formData.fnskuCode }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_submitQty') || '补货数量'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              <span style="color: #409EFF">{{ submitQty }}</span>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_unitInBox') || '装箱入数'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ unitInBox }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_ctnQty') || '补货箱数'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ ctnQty }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_shortageQty') || '缺货数量'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{
                width: '200px',
                color: shortageQty !== '0' ? 'red' : '',
              }"
            >
              {{ shortageQty }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_shippingDate') || '预计发货日期'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ formData.shippingDate }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_etaDate') || '预计上架日期'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ formData.etaDate }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_totalReplyQty') || '实际返答数量'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ v_totalReplyQty }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_totalProposeReplyQty') || '建议返答数量'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ v_totalProposeReplyQty }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_totalReplenishmentQty') || '建议补单数量'"
              :labelStyle="{ width: '140px' }"
              :contentStyle="{ width: '200px' }"
            >
              {{ v_totalReplenishmentQty }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <ReplyTable
        ref="replyTable"
        class="mt-1"
        :disabled="disabled"
        :amzReplenishmentDetailCode="amzReplenishmentDetailCode"
        @change="replyChange"
      />
    </div>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ReplyTable from '../sku-reply-table'
import EditLoading from '@/mixins/edit-loading'
import { format, add, subtract, divide } from '@/libs/util.number.js'
export default {
  components: { ReplyTable },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    amzReplenishmentDetailCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      loading: false,
      backDialogVisible: false,
      totalReplyQty: 0,
      totalProposeReplyQty: 0,
      totalReplenishmentQty: 0,
    }
  },
  computed: {
    defaultImageUrl() {
      const { defaultImageUrl } = this.formData
      return defaultImageUrl || '/image/static/img/nopic.jpg'
    },
    submitQty() {
      return format(this.formData.submitQty)
    },
    unitInBox() {
      return format(this.formData.unitInBox)
    },
    ctnQty() {
      const { submitQty, unitInBox } = this.formData
      return format(divide(submitQty, unitInBox))
    },
    shortageQty() {
      const { submitQty, invQty } = this.formData
      const shortageQty = subtract(submitQty, invQty)
      if (shortageQty <= 0) return 0
      return format(shortageQty) || '0'
    },
    v_totalReplyQty() {
      return format(this.totalReplyQty) || '0'
    },
    v_totalProposeReplyQty() {
      return format(this.totalProposeReplyQty) || '0'
    },
    v_totalReplenishmentQty() {
      return format(this.totalReplenishmentQty) || '0'
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.getData()
      this.loading = false
    },
    async getData() {
      if (!this.amzReplenishmentDetailCode) return
      const res = await this.$api
        .ecomAmzReplenishmentDetailDetailApi({
          amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
        })
        .catch(() => null)
      this.formData = res?.body || {}
    },
    replyChange(data) {
      const value = data || []
      const totalReplyQty = value
        .filter((item) => !!item.amzPurchaseNo)
        .map((item) => item.qty)
        .reduce((r, n) => add(r, n), 0)

      this.formData.invQty = totalReplyQty

      // 实际返答数量
      this.totalReplyQty = data
        .filter((item) => !!item.amzPurchaseNo)
        .map((item) => item.qty)
        .reduce((r, n) => add(r, n), 0)

      // 建议返答数量
      this.totalProposeReplyQty = data
        .filter((item) => !!item.amzPurchaseNo)
        .map((item) => item.proposeReplyQty)
        .reduce((r, n) => add(r, n), 0)

      // 建议补单数量
      this.totalReplenishmentQty = data
        .filter((item) => !item.amzPurchaseNo)
        .map((item) => item.proposeReplyQty)
        .reduce((r, n) => add(r, n), 0)
    },
    async confirm() {
      const result = await this.$refs.replyTable.validate()
      if (!result) return

      // const { submitQty, invQty } = this.formData
      // if (invQty > submitQty) {
      //   return this.$message.error(this.$l('tips_outQtyOverstep'))
      // }

      const confirm = await this.$confirm(
        this.$l('tips_confirm') || '是否要确认补货？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const items = await this.$refs.replyTable.getValidateTableData()
      const params = {
        amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
        items,
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyReplenishmentApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_confirmFailed'))
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_confirmSuccess'),
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    async outStock() {
      const confirm = await this.$confirm(
        this.$l('tips_outStock') || '是否要确认缺货？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyOutStockApi({
          amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.message_text_operationFailed'))
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.message_text_operationSucceeded'),
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
}
.sku_main {
  font-size: 13px;
  font-weight: bold;
  color: #333;
}
</style>
